module.exports = __webpack_public_path__ + "static/media/52.677194c2.jpg";